import { render } from "./SidenavCard.vue?vue&type=template&id=1cfd4cf8"
import script from "./SidenavCard.vue?vue&type=script&lang=js"
export * from "./SidenavCard.vue?vue&type=script&lang=js"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__